export default {
  form: {
    should_save_payment_info: {
      label: 'Salvează datele de plată pentru o finalizare mai rapidă',
    },
  },
};
